/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A normalized unit amenity
 */
export enum UnitAmenity {
    AIR_CONDITIONING = 'air_conditioning',
    ALL_APPLIANCES_INCLUDED = 'all_appliances_included',
    ALL_UTILITIES_INCLUDED = 'all_utilities_included',
    ATTIC = 'attic',
    BACKSPLASH = 'backsplash',
    BASEMENT = 'basement',
    BATH_TUB = 'bath_tub',
    BAY_WINDOW = 'bay_window',
    BLACK_APPLIANCES = 'black_appliances',
    BREAKFAST_BAR = 'breakfast_bar',
    BUILT_IN_DESK = 'built_in_desk',
    CARPET = 'carpet',
    CEILING_FAN = 'ceiling_fan',
    CENTRAL_AIR_CONDITIONING = 'central_air_conditioning',
    CENTRAL_HEAT = 'central_heat',
    CITY_VIEW = 'city_view',
    CONCRETE_FLOOR = 'concrete_floor',
    COURTYARD_VIEW = 'courtyard_view',
    CROWN_MOLDING = 'crown_molding',
    CUSTOM_CABINETS = 'custom_cabinets',
    DECK = 'deck',
    DEN = 'den',
    DINING_ROOM = 'dining_room',
    DISHWASHER = 'dishwasher',
    DOUBLE_SINK_VANITY = 'double_sink_vanity',
    EAT_IN_KITCHEN = 'eat_in_kitchen',
    EFFICIENT_APPLIANCES = 'efficient_appliances',
    ELECTRICITY_INCLUDED = 'electricity_included',
    FAUX_WOOD_FLOOR = 'faux_wood_floor',
    FIREPLACE = 'fireplace',
    FLOOR_TO_CEILING_WINDOWS = 'floor_to_ceiling_windows',
    FRENCH_DOORS = 'french_doors',
    FULLY_UPGRADED = 'fully_upgraded',
    FURNISHED = 'furnished',
    GARBAGE_DISPOSAL = 'garbage_disposal',
    GRANITE_COUNTERTOPS = 'granite_countertops',
    HARDWOOD_FLOOR = 'hardwood_floor',
    HEAT_INCLUDED = 'heat_included',
    HIGH_CEILINGS = 'high_ceilings',
    IN_WALL_USB_PORTS = 'in_wall_usb_ports',
    INDIVIDUAL_LOCKING_BEDROOMS = 'individual_locking_bedrooms',
    INTERNET_INCLUDED = 'internet_included',
    KITCHEN_ISLAND = 'kitchen_island',
    LARGE_BEDROOMS = 'large_bedrooms',
    LARGE_BATHROOMS = 'large_bathrooms',
    LARGE_CLOSETS = 'large_closets',
    LARGE_WINDOWS = 'large_windows',
    LINOLEUM_FLOOR = 'linoleum_floor',
    LIVING_ROOM = 'living_room',
    LOFT = 'loft',
    MARBLE_COUNTERTOPS = 'marble_countertops',
    MICROWAVE = 'microwave',
    MOUNTAIN_VIEW = 'mountain_view',
    MUD_ROOM = 'mud_room',
    NATURE_VIEW = 'nature_view',
    OPEN_FLOOR_PLAN = 'open_floor_plan',
    OVEN = 'oven',
    PANTRY = 'pantry',
    PATIO_OR_BALCONY = 'patio_or_balcony',
    PORCH = 'porch',
    PRIVATE_BATHROOM = 'private_bathroom',
    PRIVATE_ENTRANCE = 'private_entrance',
    QUARTZ_COUNTERTOPS = 'quartz_countertops',
    RANCH_STYLE = 'ranch_style',
    RANGE = 'range',
    RECENTLY_RENOVATED = 'recently_renovated',
    REFRIGERATOR = 'refrigerator',
    SEWER_INCLUDED = 'sewer_included',
    SKYLIGHT = 'skylight',
    SMART_DOORBELL = 'smart_doorbell',
    SMART_LIGHTING = 'smart_lighting',
    SMART_LOCKS = 'smart_locks',
    SMART_THERMOSTAT = 'smart_thermostat',
    STAINLESS_STEEL_APPLIANCES = 'stainless_steel_appliances',
    STOVE = 'stove',
    TILE_FLOOR = 'tile_floor',
    TRACK_LIGHTING = 'track_lighting',
    TRASH_COMPACTOR = 'trash_compactor',
    TRASH_SERVICE_INCLUDED = 'trash_service_included',
    VAULTED_CEILINGS = 'vaulted_ceilings',
    VIEW = 'view',
    VINYL_FLOOR = 'vinyl_floor',
    WALK_IN_CLOSET = 'walk_in_closet',
    WALK_IN_SHOWER = 'walk_in_shower',
    WASHER_DRYER_HOOKUPS = 'washer_dryer_hookups',
    WASHER_DRYER_IN_UNIT = 'washer_dryer_in_unit',
    WATER_INCLUDED = 'water_included',
    WATER_VIEW = 'water_view',
    WHITE_APPLIANCES = 'white_appliances',
    WINDOW_AC_UNIT = 'window_ac_unit',
    WINDOW_COVERING = 'window_covering',
    YARD = 'yard',
}
